import React from 'react';
import PropTypes from 'prop-types';
import AvatarIcon from '../../../AvatarIcon';
import Button from '../../../Button';
import Icon from '../../../Icon';

var Notification = function Notification(props) {
  var qa = props.qa,
      onClose = props.onClose,
      id = props.id,
      body = props.body,
      title = props.title,
      image = props.image,
      links = props.links;
  return /*#__PURE__*/React.createElement("div", {
    "data-qa": qa,
    className: "psw-p-xs psw-m-b-xs psw-shadow-s psw-notification psw-bg-1 psw-l-line-left psw-round-m",
    "data-id": id
  }, /*#__PURE__*/React.createElement(AvatarIcon, {
    qa: "".concat(qa, "#notification#avatarIcon"),
    withAlert: image.withAlert
  }, image.sources.map(function (source) {
    return /*#__PURE__*/React.createElement(AvatarIcon, source);
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    "data-qa": "".concat(qa, "#notification#title"),
    className: "psw-truncate-text-1",
    style: {
      fontWeight: 'bold'
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    "data-qa": "".concat(qa, "#notification#body")
  }, body), links.map(function (l) {
    return /*#__PURE__*/React.createElement("a", {
      href: l.href
    }, l.label);
  })), /*#__PURE__*/React.createElement("span", {
    className: "psw-top-right"
  }, /*#__PURE__*/React.createElement(Button, {
    "data-qa": "".concat(qa, "#notification#close"),
    onClick: onClose,
    variant: "quick-action",
    size: "small"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    size: "xs"
  }))));
};

Notification.defaultProps = {
  qa: '',
  onClose: function onClose() {},
  body: '',
  title: '',
  id: '',
  image: {
    sources: []
  },
  links: []
};
Notification.propTypes = {
  qa: PropTypes.string,
  onClose: PropTypes.func,
  body: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.shape({
    sources: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }))
  }),
  links: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string
  }))
};
export default Notification;